import { render } from "./App.vue?vue&type=template&id=7399a326&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7399a326&scoped=true&lang=css"

import exportComponent from "/Users/nadersayed/Desktop/landing/vuetemplate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7399a326"]])

export default __exports__